import { ColumnConfigType } from 'shared/types';
import { TableReportPromoType } from 'entities/reportPromo';

export const columnConfig: ColumnConfigType<TableReportPromoType>[] = [
  {
    dataFieldName: 'activity_id',
    name: 'id Акции',
    width: '6%',
  },
  {
    dataFieldName: 'activity_name',
    name: 'Название акции',
    width: '30%',
  },
  {
    dataFieldName: 'door_code',
    name: 'Код двери',
    width: '16%',
  },
  {
    dataFieldName: 'sales_point_name',
    name: 'Наименование ТТ',
    width: '16%',
  },
  {
    dataFieldName: 'city',
    name: 'Город',
    width: '10%',
  },
  {
    dataFieldName: 'sales_point_address',
    name: 'Адрес ТТ',
    width: '16%',
  },
  {
    dataFieldName: 'channel',
    name: 'Канал',
    width: '6%',
  },
  {
    dataFieldName: 'phone',
    name: 'Номер телефона',
    width: '10%',
  },
  {
    dataFieldName: 'fullName',
    name: 'ФИО',
    width: '16%',
  },
  {
    dataFieldName: 'reg_date',
    name: 'Дата регистрации',
    width: '16%',
  },
  {
    dataFieldName: 'plan',
    name: 'План',
    width: '16%',
  },
  {
    dataFieldName: 'role',
    name: 'Роль',
    width: '6%',
  },
  {
    dataFieldName: 'progress',
    name: 'Прогресс',
    width: '6%',
  },
  {
    dataFieldName: 'bonus',
    name: 'Бонус',
    width: '10%',
  },
  {
    dataFieldName: 'participation_status',
    name: 'Статус',
    width: '10%',
  },
];
